<script>
    import { getContext } from 'svelte';
    import {push} from './pt-router/Router.svelte'
    const { close } = getContext('simple-modal');

    function goToPolicies() {
        close()
        push('/policies')
    }

</script>

<h1>Welcome to Plan Together</h1>
<h2>How it Works</h2>
<ol>
    <li>Users submit items to the Map.</li>
    <li>Community can comment and vote on items.</li>
    <li>Plan Together reaches out to municipal officials with community data to make sure your voice is heard.</li>
    <li>Municipal officials can choose to get involved and communicated directly with the community.</li>
</ol>
<h2>Community Policies and Terms of Service</h2>
<p>
    All Users are expected to follow the <a on:click={goToPolicies}>Community policies</a> and agree to the terms and conditions. We hope you have a great time here!
</p>

<button on:click={() => close()}>I Understand</button>